'use es6';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCurrentRowInsertTargetInfo, getCurrentColumnInsertTargetInfo, getCurrentGridLayoutDropTargetInfo, getDragItemIsHidden } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { VerticalInsertDropTarget, HorizontalInsertDropTarget } from 'layout-dnd-components/InsertDropTargets';
import { dropTargetLocations, dropTargetOrientation, dropTypes } from 'InpageEditorUI/lib/layoutSection/constants';
import { SHADE_BOTH } from 'layout-dnd-components/InsertDropTargets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  BEFORE,
  AFTER,
  SPLIT_ROW_BEFORE,
  SPLIT_ROW_AFTER
} = dropTargetLocations;
const SHADE_THICKNESS = 20;
const mapStateToProps = state => {
  return {
    rowDropTargetInfo: getCurrentRowInsertTargetInfo(state),
    columnDropTargetInfo: getCurrentColumnInsertTargetInfo(state),
    gridLayoutDropTargetInfo: getCurrentGridLayoutDropTargetInfo(state),
    dragItemIsHidden: getDragItemIsHidden(state)
  };
};
const renderColumnDropTarget = columnDropTargetInfo => {
  if (columnDropTargetInfo) {
    const {
      top,
      left,
      height,
      width,
      type,
      shade
    } = columnDropTargetInfo;
    if (type === BEFORE || type === AFTER) {
      return /*#__PURE__*/_jsx(VerticalInsertDropTarget, {
        top: Math.round(top),
        left: Math.round(left),
        height: Math.round(height),
        shade: shade,
        shadeThickness: 0,
        ballRadius: 9
      });
    } else if (type === SPLIT_ROW_BEFORE || type === SPLIT_ROW_AFTER) {
      return /*#__PURE__*/_jsx(HorizontalInsertDropTarget, {
        top: Math.round(top),
        left: Math.round(left),
        width: Math.round(width),
        shade: shade,
        shadeThickness: shade === SHADE_BOTH ? 0 : SHADE_THICKNESS,
        ballRadius: 9
      });
    }
  }
  return null;
};
const renderRowDropTarget = rowDropTargetInfo => {
  if (rowDropTargetInfo) {
    const {
      top,
      left,
      width,
      shade
    } = rowDropTargetInfo;
    return /*#__PURE__*/_jsx(HorizontalInsertDropTarget, {
      top: Math.round(top),
      left: Math.round(left),
      width: Math.round(width),
      shade: shade,
      shadeThickness: shade === SHADE_BOTH ? 0 : SHADE_THICKNESS,
      ballRadius: 9
    });
  }
  return null;
};
function isTableDropType(dropType) {
  return dropType === dropTypes.INSERT_INTO_TABLE_CELL;
}
const renderGridLayoutDropTarget = gridLayoutDropTargetInfo => {
  if (!gridLayoutDropTargetInfo) {
    return null;
  }
  const {
    dropType,
    height,
    left,
    orientation,
    top,
    width
  } = gridLayoutDropTargetInfo;
  if (dropType === dropTypes.INSERT_INTO_EMPTY_HORIZONTAL_STACK || dropType === dropTypes.INSERT_INTO_EMPTY_VERTICAL_STACK) {
    return null;
  }
  if (orientation === dropTargetOrientation.HORIZONTAL) {
    return /*#__PURE__*/_jsx(HorizontalInsertDropTarget, {
      top: Math.round(top),
      left: Math.round(left),
      width: Math.round(width),
      shadeThickness: 0,
      ballRadius: 0
    });
  } else if (orientation === dropTargetOrientation.VERTICAL) {
    return /*#__PURE__*/_jsx(VerticalInsertDropTarget, {
      top: Math.round(top),
      left: Math.round(left),
      height: Math.round(height),
      shadeThickness: 0,
      ballRadius: 0
    });
  }
  if (isTableDropType(gridLayoutDropTargetInfo.dropType)) {
    return /*#__PURE__*/_jsx("div", {
      style: {
        position: 'absolute',
        top: Math.round(top),
        left: Math.round(left),
        height: Math.round(height),
        width: Math.round(width),
        backgroundColor: 'rgba(0, 0, 0, 0.2)'
      }
    });
  }
  return null;
};
const LayoutSectionDropTargetsContainer = ({
  rowDropTargetInfo,
  columnDropTargetInfo,
  gridLayoutDropTargetInfo,
  dragItemIsHidden
}) => {
  if (!dragItemIsHidden) {
    return /*#__PURE__*/_jsxs("div", {
      children: [renderColumnDropTarget(columnDropTargetInfo), renderRowDropTarget(rowDropTargetInfo), renderGridLayoutDropTarget(gridLayoutDropTargetInfo)]
    });
  }
  return null;
};
LayoutSectionDropTargetsContainer.propTypes = {
  rowDropTargetInfo: PropTypes.object,
  columnDropTargetInfo: PropTypes.object,
  dragItemIsHidden: PropTypes.bool
};
export default connect(mapStateToProps)(LayoutSectionDropTargetsContainer);